'use client';

import { FC } from 'react';

import { LeadModal } from '@telialt/common-lead/src';

import { PLAN_ORDERING_TEST_ID } from '../constants';
import { usePlanOrderLeadModalControls } from './usePlanOrderLeadModalControls';

type Props = { onCancel?: () => void };

export const PlanOrderLeadModal: FC<Props> = ({ onCancel }) => {
    const { isPlanOrderLeadModalOpen, closePlanOrderLeadModal, leadModalData } = usePlanOrderLeadModalControls();

    return (
        <LeadModal
            leadText={leadModalData?.leadText}
            gaTracking={leadModalData?.gaTracking}
            isOpen={isPlanOrderLeadModalOpen}
            onClose={() => {
                closePlanOrderLeadModal();
                onCancel?.();
            }}
            dataTest={PLAN_ORDERING_TEST_ID.ORDER_LEAD_MODAL}
        />
    );
};
